module.exports = {"654023100":"水定镇","654023101":"清水河镇","654023102":"芦草沟镇","654023103":"惠远镇","654023104":"萨尔布拉克镇","654023105":"兰干镇","654023201":"三道河乡","654023204":"三宫乡","654023205":"大西沟乡","654023403":"良种繁育中心","654023509":"兵团六十六团分部"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654023.json
// module id = 3272
// module chunks = 0